module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('link', {
    attrs: {
      "href": "../styles/9780061970009_template.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('title', [_vm._v("The Fires of Jubilee")]), _vm._v(" "), _c('h2', {
    staticClass: "aboutAuthorHead"
  }, [_c('b', [_vm._v("CONTENTS")])]), _vm._v(" "), _c('nav', {
    attrs: {
      "epub:type": "toc",
      "id": "toc"
    }
  }, [_c('ol', [_c('li', {
    staticClass: "toc_1",
    attrs: {
      "epub:type": "frontmatter",
      "id": "ded"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780061970009_Dedication#ded01",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Dedication")])])]), _vm._v(" "), _c('li', {
    staticClass: "toc_1",
    attrs: {
      "epub:type": "frontmatter",
      "id": "ep"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780061970009_Epigraph#ep01",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Epigraph")])])]), _vm._v(" "), _c('li', {
    staticClass: "toc_1",
    staticStyle: {
      "margin-top": "1em"
    },
    attrs: {
      "epub:type": "chapter",
      "id": "fm_01"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780061970009_Frontmatter#fm01"
    }
  }, [_c('i', [_vm._v("Foreword to the Perennial Library Edition")])])]), _vm._v(" "), _c('li', {
    staticClass: "toc_1",
    staticStyle: {
      "padding-top": "1em"
    },
    attrs: {
      "epub:type": "chapter",
      "id": "pro_01"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780061970009_Prologue#pro01"
    }
  }, [_c('b', [_vm._v("PROLOGUE")]), _vm._v(": Southampton County, 1831")])]), _vm._v(" "), _c('li', {
    staticClass: "toc_1",
    staticStyle: {
      "padding-top": "1em"
    },
    attrs: {
      "epub:type": "chapter",
      "id": "pt_01"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780061970009_Part_1#pt01"
    }
  }, [_c('i', [_vm._v("Part One")]), _vm._v(": "), _c('b', [_vm._v("THIS INFERNAL SPIRIT OF SLAVERY")])])]), _vm._v(" "), _c('li', {
    staticClass: "toc_1",
    staticStyle: {
      "padding-top": "1em"
    },
    attrs: {
      "epub:type": "chapter",
      "id": "pt_02"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780061970009_Part_2#pt02",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Part Two")]), _vm._v(": "), _c('b', [_vm._v("GO SOUND THE JUBILEE")])])]), _vm._v(" "), _c('li', {
    staticClass: "toc_1",
    staticStyle: {
      "padding-top": "1em"
    },
    attrs: {
      "epub:type": "chapter",
      "id": "pt_03"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780061970009_Part_3#pt03",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Part Three")]), _vm._v(": "), _c('b', [_vm._v("JUDGMENT DAY")])])]), _vm._v(" "), _c('li', {
    staticClass: "toc_1",
    staticStyle: {
      "padding-top": "1em"
    },
    attrs: {
      "epub:type": "chapter",
      "id": "pt_04"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780061970009_Part_4#pt04",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Part Four")]), _vm._v(": "), _c('b', [_vm._v("LEGACY")])])]), _vm._v(" "), _c('li', {
    staticClass: "toc_1",
    staticStyle: {
      "padding-top": "1em"
    },
    attrs: {
      "epub:type": "chapter",
      "id": "epil_01"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780061970009_Epilogue#epil01",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("EPILOGUE")]), _vm._v(": Southampton County, 1973")])]), _vm._v(" "), _c('li', {
    staticClass: "toc_1",
    staticStyle: {
      "padding-top": "1em"
    },
    attrs: {
      "epub:type": "chapter",
      "id": "bm_01"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780061970009_Note#bm01",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Reference Notes")])])]), _vm._v(" "), _c('li', {
    staticClass: "toc_1",
    staticStyle: {
      "padding-top": "1em"
    },
    attrs: {
      "epub:type": "chapter",
      "id": "ind_01"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780061970009_Backmatter#ind01",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Searchable Terms")])])]), _vm._v(" "), _c('li', {
    staticClass: "toc_1",
    staticStyle: {
      "padding-top": "1em"
    },
    attrs: {
      "epub:type": "chapter",
      "id": "map_01"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780061970009_Map#map01",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("MAPS")])])]), _vm._v(" "), _c('li', {
    staticClass: "toc_1",
    staticStyle: {
      "padding-top": "1em"
    },
    attrs: {
      "epub:type": "chapter",
      "id": "map_1"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780061970009_Map#map1",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Southeastern Virginia, 1831")])])]), _vm._v(" "), _c('li', {
    staticClass: "toc_1",
    staticStyle: {
      "padding-top": "1em"
    },
    attrs: {
      "epub:type": "chapter",
      "id": "map_2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780061970009_Map#map2",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Nat Turner Country")])])]), _vm._v(" "), _c('li', {
    staticClass: "toc_1",
    staticStyle: {
      "margin-top": "0.5em"
    },
    attrs: {
      "epub:type": "backmatter",
      "id": "rps"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780061970009_PS#ps",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("P.S. Insights, Interviews & More . . .*")])]), _vm._v(" "), _c('li', {
    staticClass: "toc_1",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "epub:type": "backmatter",
      "id": "rata"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780061970009_PS_About_the_Author#ata",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the author")])]), _vm._v(" "), _c('li', {
    staticClass: "toc_1",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "epub:type": "backmatter",
      "id": "ratb"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780061970009_PS_About_Book#atb",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the book")])]), _vm._v(" "), _c('li', {
    staticClass: "toc_1",
    staticStyle: {
      "text-indent": "1em",
      "margin-bottom": "1em"
    },
    attrs: {
      "epub:type": "backmatter",
      "id": "rread"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780061970009_PS_Read_On#read",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Read on")])]), _vm._v(" "), _c('li', {
    staticClass: "toc_1",
    staticStyle: {
      "margin-top": "2em"
    },
    attrs: {
      "epub:type": "chapter",
      "id": "adc_01"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780061970009_Also_by#adc01",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Books by Stephen B. Oates")])])]), _vm._v(" "), _c('li', {
    staticClass: "toc_1",
    attrs: {
      "epub:type": "chapter",
      "id": "cop_01"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780061970009_Copyright#cop01",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Copyright")])])]), _vm._v(" "), _c('li', {
    staticClass: "toc_1",
    attrs: {
      "epub:type": "chapter",
      "id": "atp_01"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/About_the_Publisher#atp01",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("About the Publisher")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "hide1"
  }, [_c('nav', {
    attrs: {
      "epub:type": "landmarks",
      "hidden": "hidden"
    }
  }, [_c('h1', {
    staticClass: "toc"
  }, [_vm._v("Guide")]), _vm._v(" "), _c('ol', {
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_c('li', [_c('span', {
    attrs: {
      "epub:type": "cover",
      "href": "#/text/9780061970009_Cover",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cover")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "epub:type": "toc",
      "href": "#/text/nav"
    }
  }, [_vm._v("Contents")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "epub:type": "bodymatter",
      "href": "#/text/9780061970009_Part_1"
    }
  }, [_vm._v("Part 1")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-01d29e16","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/nav.vue
// module id = 69
// module chunks = 0